module.exports = __webpack_public_path__ + "img/kong.90776e7f.svg";